import { useSocialMedia, SOCIAL_MEDIA } from '../../config';
import { getUserLanguage } from '../../utils/language';

const Hero = ({ title, description, videoPath }) => {
  const { socialMedia, error } = useSocialMedia(); // Fetch dynamic social media URLs
  const language = getUserLanguage();

  // Log error if social media fetch fails
  if (error) {
    console.error('[Hero] Social media fetch error:', error.message, error.stack);
  }

  // Use static SOCIAL_MEDIA as fallback if fetch fails
  const displaySocialMedia = error ? SOCIAL_MEDIA : socialMedia;

  // Dynamické texty podle jazyka
  const texts = {
    cs: {
      badge: 'Profesionální drift tým',
      defaultTitle: '#NORISK<span>NODRIFT</span>',
      defaultDescription: 'Jsme profesionální drift tým z České Lípy specializující se na závodění, exhibice a drift zážitky. Zažijte adrenalin driftingu s námi!',
      eventsButton: 'Naše events',
      driftTaxiButton: 'Drift taxi',
      scrollText: 'Scroll',
    },
    en: {
      badge: 'Professional Drift Team',
      defaultTitle: '#NORISK<span>NODRIFT</span>',
      defaultDescription: 'We are a professional drift team from Česká Lípa specializing in racing, exhibitions, and drift experiences. Experience the adrenaline of drifting with us!',
      eventsButton: 'Our Events',
      driftTaxiButton: 'Drift Taxi',
      scrollText: 'Scroll',
    },
  };

  const currentText = texts[language] || texts.en; // Fallback na angličtinu

  // Parse HTML v title (pro span element)
  const renderTitle = () => {
    return { __html: title || currentText.defaultTitle };
  };

  return (
    <header id="home" className="hero-section">
      <div className="video-container">
        <video autoPlay muted loop className="video-background" preload="none">
          <source src="/images/videos/hero-background.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="hero-overlay"></div>

      <div className="hero-content-wrapper">
        <div className="hero-content">
          <span className="hero-badge">{currentText.badge}</span>

          <h1 className="hero-title" dangerouslySetInnerHTML={renderTitle()}></h1>

          <p className="hero-description">
            {description || currentText.defaultDescription}
          </p>

          <div className="hero-buttons">
            <a href="#events" className="btn-drift">
              <i className="fas fa-calendar-alt text-xs mr-2"></i>
              {currentText.eventsButton}
            </a>
            <a href="#drift-taxi" className="btn-outline">
              <i className="fas fa-car text-xs mr-2"></i>
              {currentText.driftTaxiButton}
            </a>
          </div>

          <div className="hero-social">
            <a href={displaySocialMedia.INSTAGRAM} target="_blank" rel="noopener" className="hero-social-icon">
              <i className="fab fa-instagram"></i>
            </a>
            <a href={displaySocialMedia.FACEBOOK} target="_blank" rel="noopener" className="hero-social-icon">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href={displaySocialMedia.YOUTUBE} target="_blank" rel="noopener" className="hero-social-icon">
              <i className="fab fa-youtube"></i>
            </a>
            <a href={displaySocialMedia.TIKTOK} target="_blank" rel="noopener" className="hero-social-icon">
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="scroll-down">
        <a href="#team" className="text-white/70 hover:text-white transition-colors flex flex-col items-center">
          <span className="block text-sm">{currentText.scrollText}</span>
          <i className="fas fa-chevron-down"></i>
        </a>
      </div>

      <div className="tire-mark-animation tire-mark"></div>
    </header>
  );
};

export default Hero;